import { BankAccount } from '@liveauctioneers/caterwaul-components/types/BankAccount';
import ms from 'ms';

export const BANK_ACCOUNTS_CACHE_TIME = ms('20m');

export type BankAccountSlice = {
    bankAccounts: BankAccount[];
    bankAccountsLoaded: number;
    bankAccountsLoading: boolean;
    errorMessage: string;
    plaidError: boolean;
    plaidFetching: boolean;
    plaidLinkTokens: { [key: string]: string };
    plaidSuccess: boolean;
};

export const defaultBankAccountSlice: BankAccountSlice = {
    bankAccounts: [],
    bankAccountsLoaded: 0,
    bankAccountsLoading: false,
    errorMessage: '',
    plaidError: false,
    plaidFetching: false,
    plaidLinkTokens: {},
    plaidSuccess: false,
};
